import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './ClientTestimonial.css';
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// Import testimonial images (used as fallback for missing image_url)
import testimonial1 from '../assets/images/c1.png';
import testimonial2 from '../assets/images/c1.png';
import testimonial3 from '../assets/images/c1.png';

// Define useReviews hook inline
const useReviews = () => {
  return useQuery({
    queryKey: ['reviews'],
    queryFn: async () => {
      const response = await api.get('/get-app-reviews?is_web=1&about_page=1');
      return response.data;
    },
    staleTime: 3 * 60 * 1000, // 3 minutes
    cacheTime: 3 * 60 * 1000, // 3 minutes
    retry: 3,
  });
};

const Testimonial = () => {
  const { data: reviews, isLoading, isError } = useReviews();

  // Map API reviews to slider items
  const sliderItems = reviews?.dataset?.data?.reviews
    ?.filter((review) => review.status === 1)
    .map((review, index) => ({
      img: review.image_url || [testimonial1, testimonial2, testimonial3][index % 3],
      stars: Math.round(review.rating) || 5,
      title: review.review?.length > 130 ? review.review.slice(0, 130) + '...' : review.review || 'No review provided',
      name: review.user_name || 'Anonymous User',
      designation: 'Vidyakasam User',
    })) || [];

  // Adjust slider settings based on number of items
  const settings = {
    dots: sliderItems.length > 1, // Show dots only if more than one item
    infinite: sliderItems.length > 1, // Disable infinite scroll for single item
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: sliderItems.length > 1, // Disable autoplay for single item
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: sliderItems.length > 1, // Hide arrows for single item
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const CustomPrevArrow = (props) => (
    <button
      {...props}
      className="slick-prev custom-arrow"
      aria-label="Previous"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="currentColor" />
      </svg>
    </button>
  );

  const CustomNextArrow = (props) => (
    <button
      {...props}
      className="slick-next custom-arrow"
      aria-label="Next"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" fill="currentColor" />
      </svg>
    </button>
  );

  if (isLoading) {
    return (
      <div className="testimonial-slider about-testimonial">
        <div className="item">
          <div className="testimonial_box">
            <div className="testi_img">
              <span className="shimmer" style={{ width: '100px', height: '100px', borderRadius: '50%' }} />
              <div className="user_info">
                <div className="star">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className="shimmer" style={{ width: '20px', height: '20px' }} />
                  ))}
                </div>
                <h5 className="test-text">
                  <span className="shimmer" style={{ width: '300px', height: '20px' }} />
                </h5>
                <h6>
                  <span className="shimmer" style={{ width: '150px', height: '20px' }} />
                </h6>
                <p className="mb-0">
                  <span className="shimmer" style={{ width: '100px', height: '20px' }} />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isError || sliderItems.length === 0) {
    return null; // Render nothing if there's an error or no reviews
  }

  return (
    <div className="testimonial-slider about-testimonial">
      <Slider {...settings} prevArrow={<CustomPrevArrow />} nextArrow={<CustomNextArrow />}>
        {sliderItems.map((item, index) => (
          <div className="item" key={index}>
            <div className="testimonial_box">
              <div className="testi_img">
                <img
                  className="user_img"
                  src={item.img}
                  alt={item.name}
                  onError={(e) => {
                    e.target.src = [testimonial1, testimonial2, testimonial3][index % 3];
                  }}
                />
                <div className="user_info">
                  <div className="star">
                    {[...Array(5)].map((_, i) => (
                      <span key={i}>
                        <i
                          className={`fa-solid fa-star ${i < item.stars ? '' : 'fa-star-o'}`}
                          aria-hidden="true"
                        ></i>
                      </span>
                    ))}
                  </div>
                  <h5 className="test-text">{item.title}</h5>
                  <h6>{item.name}</h6>
                  <p className="mb-0">{item.designation}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Testimonial;
